export {default as data} from './index.json';
import {Component} from 'intact';
import template from './index.vdt';

export default class extends Component {
    static template = template;

    static defaults() {
        return {
            data: Array.apply(null, {length: 12} as unknown[])
                .map((v, i) => ({label: i + 1 + '月', value: i})),
            value: 0
        };
    }
}